import React from 'react';
import { Card } from "react-bootstrap";
import face_zsombor_berezvai from "../../assets/img/face_zombor_berezvai.jpg";
import ShowMoreText from "react-show-more-text";
import proj_bubi_data_analytics from "../../assets/img/proj_bubi_data_analytics.png";

const Zsombor_Berezvai_bubi = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_bubi_data_analytics} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_zsombor_berezvai}
              /* this will be the text on the banner */
              alt="Bubi data anlytics: the usage patterns of the Budapest bicycle-sharing system"
            />{" "}
            <p className="text7">Zombor Berezvai</p>
            <br />
            <p className="text8">
              Head of Centre{" "}
            </p>
            <p className="text8">Corvinus Centre for Transport Studies, Corvinus University of Budapest</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Bicycle sharing is no longer a niche mode of commuting; it is now a vital part of the transport networks of large cities. 
            Budapest is no exception either; with the recent launch of Bubi 3.0, the system now offers both normal and e-bikes. 
            The project’s main goal is either to better understand how different decisions/shocks affect Bubi usage or how Bubi is 
            integrated with other transport modes (e.g., public transport) or to provide ideas for the future development of the system. 
            Bubi usage data and other relevant datasets will be available in cooperation with the BKK Centre for Budapest Transport.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://www.nature.com/articles/s41598-024-68677-0">Berezvai, Z., Basile, V., Kálecz-Simon, A., & Bakó B. (2024). Investigating the 
                impact of fuel price shocks on bicycle sharing usage in Budapest, Sci Rep, 14, 18355.</a>
                </li>
                <li>
                <a href="https://www.sciencedirect.com/science/article/pii/S2590198222001348">Berezvai, Z. (2022). Short- and long-term effects of COVID-19 on bicycle 
                sharing usage. Transportation Research Interdisciplinary Perspectives, 15, 100674.</a>
                </li>
                <li>
                <a href="https://www.sciencedirect.com/science/article/pii/S096585641831437X">Bakó, B., Berezvai, Z., Isztin, P., & Vigh E.Z. (2020). Does Uber affect bicycle-sharing 
                usage? Evidence from a natural experiment in Budapest. Transportation Research Part A, 133, 290–302.</a>
                </li>
            
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Zsombor_Berezvai_bubi;